const chartsData = [
  {
    id: 0,
    name: "Bitcoin",
    price: 218,
    percentageChange: 5.6,
    lowest: 207.67,
    highest: 290.2,
    chartData: [80, 200, 260, 240, 250],
    chartColor: "#FB8C00",
  },
  {
    id: 1,
    name: "Ripple",
    price: 7,
    percentageChange: 1.6,
    lowest: 207.67,
    highest: 290.2,
    chartData: [80, 200, 260, 180, 250],
    chartColor: "#9C27B0",
  },
  {
    id: 2,
    name: "Monero",
    price: 22,
    percentageChange: 1.16,
    lowest: 207.67,
    highest: 290.2,
    chartData: [80, 200, 200, 240, 250],
    chartColor: "#EC407A",
  },
  {
    id: 3,
    name: "Iota",
    price: 105,
    percentageChange: 2.9,
    lowest: 207.67,
    highest: 290.2,
    chartData: [110, 250, 160, 250],
    chartColor: "#536DFE",
  },
];

export default chartsData;
